import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from '@angular/router';
import { FeatureFlagService } from '../services/feature-flag.service';

@Injectable({
	providedIn: 'root',
})
export class FeatureFlagGuard implements CanActivate {
	constructor(private featureFlagService: FeatureFlagService, private router: Router) {}

	canActivate(next: ActivatedRouteSnapshot, _state: RouterStateSnapshot) {
		const isFeatureEnabled = this.featureFlagService.isFeatureEnabled(next.data.feature_flag);
		const isFeatureEnabledV2 = this.featureFlagService.isFeatureEnabledV2(next.data.feature_flag);
		if (!isFeatureEnabled && !isFeatureEnabledV2) {
			console.log('Feature not accessible!');
			return this.router.createUrlTree(['/home']);
		}
		return true;
	}
}
